module.exports = __webpack_public_path__ + "media/images/flags/16/Senegal-bf6f196dc5a542834293d32d67d31c26.png";